/**
 * World chat box.
 *
 * One slice of the base-view stylesheet. `styles/index.ts` concatenates
 * every slice into the single sheet `injectStyles` mounts — the split is
 * about OWNERSHIP, not about emitting more than one style element.
 *
 * NO BACKTICKS anywhere in this file, comments included: the export below
 * is one template literal and a stray backtick terminates it. That has
 * broken the build twice, both times with esbuild pointing at a line ten
 * rows away from the cause. Write class names in plain text.
 */
export default `
/* ─── World chat ───────────────────────────────────────────────────────────
   A bounded corner box, NOT a scrim — chat is read while walking around, which
   is the whole reason it is a panel in the corner and not a screen. Above the
   1001 panel layer so it survives an open inventory. It opens ABOVE the
   bottom-left action dock (2026-10-16), standing on the height the dock
   publishes as --bv-ab-dock-h (ui/action-bar.ts), so the World Chat button
   that opened it stays visible and clickable underneath. The dev debug
   overlay shares that spot and is simply covered while chat is open. */
.bv-chat {
  position: absolute; left: 12px; bottom: calc(20px + var(--bv-ab-dock-h, 0px)); z-index: 1050;
  width: min(360px, 40vw); height: min(300px, 46vh);
  display: flex; flex-direction: column;
  background: rgba(15,9,5,0.72);
  border: 1px solid var(--line); border-radius: var(--radius-well);
  box-shadow: inset 0 0 0 1px rgba(210,164,86,0.08), 0 8px 24px rgba(0,0,0,0.45);
  backdrop-filter: blur(3px);
  overflow: hidden;
}
.bv-chat[hidden] { display: none; }
.bv-chat-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 6px 8px 6px 10px; border-bottom: 1px solid var(--line);
  background: rgba(122,90,48,0.14);
}
.bv-chat-title {
  font: 700 10px/1.4 var(--font-display); letter-spacing: 0.12em;
  text-transform: uppercase; color: var(--brass-bright);
}
.bv-chat-log {
  flex: 1 1 auto; overflow-y: auto; overflow-x: hidden;
  padding: 8px 10px; scrollbar-width: thin;
}
.bv-chat-row {
  display: grid; grid-template-columns: auto auto 1fr; gap: 6px;
  align-items: baseline; margin-bottom: 3px;
  font: 12px/1.5 var(--font-technical); word-break: break-word;
}
.bv-chat-time { color: var(--bone-faint); font-size: 10px; font-variant-numeric: tabular-nums; }
.bv-chat-who { color: var(--brass-bright); font-weight: 700; }
/* Your own name, in the palette's one real green.
   Was --moss (#74854a), the "success/healthy" olive: beside --brass-bright
   (#dcb06a) at 12px bold it reads as a slightly duller brass, not as a
   different colour at all, and Janeks asked for green (2026-09-19).
   --terminal (#6fdc8f) is the CRT-green already used for technical readouts,
   so this stays inside the Salvage Codex palette rather than inventing a
   green of its own. The self flag is set by the SERVER too
   (world-chat.service.ts: row.senderId === viewerId), so history lines are
   green on first paint, not only the ones sent this session.

   NO BACKTICKS IN THIS FILE. The whole stylesheet is one template literal,
   so a backtick in a comment terminates the string and esbuild then blames a
   line nowhere near it. Cost one build to relearn. */
.bv-chat-row-self .bv-chat-who { color: var(--terminal); }
.bv-chat-text { color: var(--bone); min-width: 0; }
.bv-chat-form { display: flex; gap: 6px; padding: 8px; border-top: 1px solid var(--line); }
.bv-chat-input {
  flex: 1 1 auto; min-width: 0; padding: 6px 8px;
  font: 12px/1.4 var(--font-technical); color: var(--bone);
  background: var(--well); border: 1px solid var(--line); border-radius: var(--radius-tape);
}
.bv-chat-input::placeholder { color: var(--bone-faint); }
.bv-chat-input:focus { outline: none; border-color: var(--brass); box-shadow: 0 0 0 1px rgba(210,164,86,0.3); }
.bv-chat-send {
  flex: none; padding: 6px 12px; cursor: pointer;
  font: 700 11px/1.4 var(--font-display); letter-spacing: 0.06em; text-transform: uppercase;
  color: var(--bone); background: rgba(122,90,48,0.35);
  border: 1px solid var(--line); border-radius: var(--radius-tape);
}
.bv-chat-send:hover { background: rgba(122,90,48,0.55); }
`;
